import debounce from "debounce-promise";
import { RequestSupportInputType } from "healthex-common/request.support.dtos";
import { withoutUndefinedNullOrEmptyProperties } from "healthex-common/utils";
import { DocumentRetrievalClientFailureStage, logDocumentRetrievalClientError } from "../Infra/logDocumentRetrievalClientError";
const SEARCH_DEBOUNCE_MILLISECONDS = 300;
const EMPTY_RESPONSE = {
    totalHits: 0,
    offset: 0,
    limit: 0,
    hasMore: false,
    searchMode: "name",
    results: [],
};
export const SearchAnalyticsEvent = {
    SEARCH_MODAL_OPENED: "SearchModalOpened",
    SEARCH_RESULT_SELECTED: "SearchResultSelected",
    SEARCH_SUGGESTION_SELECTED: "SearchSuggestionSelected",
    SEARCH_FHIR_VENDOR_LOOKUP_FAILED: "SearchFhirVendorLookupFailed",
};
export class PatientPortalSearchManager {
    constructor(patientPortalSearchService, healthExSupportService, authManager, documentRetrievalManager) {
        this.patientPortalSearchService = patientPortalSearchService;
        this.healthExSupportService = healthExSupportService;
        this.authManager = authManager;
        this.documentRetrievalManager = documentRetrievalManager;
        this.search = debounce((criteria) => {
            return this.executeSearch(criteria);
        }, SEARCH_DEBOUNCE_MILLISECONDS);
        this.loadPage = (criteria) => {
            return this.executeSearch(criteria);
        };
    }
    async executeSearch(criteria) {
        var _a, _b, _c;
        const batchId = (_a = this.documentRetrievalManager.retrieval) === null || _a === void 0 ? void 0 : _a.batchId;
        try {
            const optionalFilters = withoutUndefinedNullOrEmptyProperties({
                city: (_b = criteria.city) === null || _b === void 0 ? void 0 : _b.trim(),
                state: criteria.state,
                zipcode: (_c = criteria.zipcode) === null || _c === void 0 ? void 0 : _c.trim(),
                platformType: criteria.platformType,
                limit: criteria.limit,
                offset: criteria.offset,
            });
            const inputPayload = {
                query: criteria.query,
                isSandbox: this.authManager.isSandbox,
                ...(batchId ? { batchId } : {}),
                ...optionalFilters,
            };
            return await this.patientPortalSearchService.search(inputPayload);
        }
        catch (error) {
            logDocumentRetrievalClientError("error", "Patient portal search failed", {
                failureStage: DocumentRetrievalClientFailureStage.CATALOG_SEARCH,
                batchId,
                query: criteria.query,
                platformType: criteria.platformType,
                errorMessage: error instanceof Error ? error.message : String(error),
            });
            return EMPTY_RESPONSE;
        }
    }
    async resolveCatalogEndpoint(brandId, portalId, endpointId, options) {
        try {
            return await this.patientPortalSearchService.resolveEndpoint({
                brandId,
                portalId,
                endpointId,
                endpointPlatformType: options === null || options === void 0 ? void 0 : options.endpointPlatformType,
                endpointUrl: options === null || options === void 0 ? void 0 : options.endpointUrl,
            });
        }
        catch (error) {
            logDocumentRetrievalClientError("error", "Resolve catalog endpoint failed", {
                failureStage: DocumentRetrievalClientFailureStage.RESOLVE_ENDPOINT,
                brandId,
                portalId,
                endpointId,
                platformType: options === null || options === void 0 ? void 0 : options.endpointPlatformType,
                fhirEndpoint: options === null || options === void 0 ? void 0 : options.endpointUrl,
                errorMessage: error instanceof Error ? error.message : String(error),
            });
            return null;
        }
    }
    async requestProvider(query, patientId) {
        await this.healthExSupportService.requestSupport({
            type: RequestSupportInputType.REQUEST_A_PROVIDER,
            patientId,
            searchQuery: query,
        });
    }
}
